import { defineStore } from 'pinia';

export default defineStore('imageryStateStore', () => {
  const currentPage = ref<number>(1);
  const firstAltDot = ref<number>(1);
  const currentPageOnHover = ref<number | null>(null);
  const isOverlayOpen = ref<boolean>(false);

  const zoomStates = ref({
    scale: 1,
    isZoomedIn: false,
    zoomStartValues: {},
    boundaries: {},
  });

  return {
    currentPage,
    firstAltDot,
    currentPageOnHover,
    isOverlayOpen,
    zoomStates,
  };
});
